<template>
  <div class="flex items-center py-4 border-b border-noir-800 last:border-0">
    <!-- Thumbnail -->
    <div class="h-20 w-20 flex-shrink-0 overflow-hidden rounded-lg border border-noir-700 hover-zoom">
      <img 
        :src="item.productData.image || '/placeholder-product.png'" 
        :alt="item.productData.name"
        class="h-full w-full object-cover object-center transition-transform duration-300"
      />
    </div>

    <div class="ml-4 flex flex-1 flex-col">
      <div>
        <div class="flex justify-between text-base font-medium">
          <h3 class="text-sm font-display text-cream-100 line-clamp-2">{{ item.productData.name }}</h3>
          <p class="ml-4 text-sm font-mono font-semibold text-gold-400">${{ item.subtotal.toFixed(2) }}</p>
        </div>
      </div>
      
      <div class="flex flex-1 items-end justify-between text-sm">
        <div class="flex items-center space-x-2">
          <template v-if="!item.productData.isDigital">
            <button 
              @click="$emit('update:quantity', item.id, item.quantity - 1)"
              class="w-8 h-8 flex items-center justify-center rounded-full border border-noir-600 text-noir-300 hover:text-gold-400 hover:border-gold-400/30 disabled:opacity-30 transition-colors"
              :disabled="item.quantity <= 1 || loading"
            >-</button>
            <span class="font-medium w-8 text-center text-cream-100 font-mono">{{ item.quantity }}</span>
            <button 
              @click="$emit('update:quantity', item.id, item.quantity + 1)"
              class="w-8 h-8 flex items-center justify-center rounded-full border border-noir-600 text-noir-300 hover:text-gold-400 hover:border-gold-400/30 disabled:opacity-30 transition-colors"
              :disabled="loading"
            >+</button>
          </template>
          <template v-else>
            <span class="text-xs text-gold-400 font-medium px-3 py-1 bg-gold-400/10 rounded-full border border-gold-400/20">{{ t('cart.item.digital') }}</span>
          </template>
        </div>

        <div class="flex">
          <button 
            type="button" 
            @click="$emit('remove', item.id)"
            class="font-medium text-noir-400 hover:text-burgundy-800 disabled:opacity-30 transition-colors text-xs uppercase tracking-wider font-sans"
            :disabled="loading"
          >
            {{ t('common.remove') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { CartItem } from '@/modules/cart/domain/entities/CartItem';

defineProps<{
  item: CartItem;
  loading?: boolean;
}>();

defineEmits<{
  (e: 'update:quantity', id: string, quantity: number): void;
  (e: 'remove', id: string): void;
}>();

const { t } = useI18n();
</script>
